'use strict';

module.exports = {
    initFlipCard: function () {
        $(document).on('click', '.flip-card', function () {
            $(this).toggleClass('is-flipped');
        });
    }
};
